import { useState } from "react";
import { viewpoints } from "@/mocks/homeData";

type V = (typeof viewpoints)[number];

export default function Viewpoints() {
  const [picked, setPicked] = useState<Record<number, boolean>>({});

  const agree = (i: number, v: V) => {
    setPicked((p) => ({ ...p, [i]: !p[i] }));
    void v;
  };

  return (
    <section id="viewpoint" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="mb-3 inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wider text-accent-900">
            <i className="ri-chat-poll-line text-accent-700"></i>
            同题异见
          </span>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-[34px]">
            各方观点 · 一个话题三种声音
          </h2>
          <p className="mt-3 text-sm text-foreground-600 md:text-base">
            不用只听一家之言，把支持、反对、中立摆在一起，你站哪边？
          </p>
        </div>
        <div className="mb-1 hidden md:block">
          <span className="rounded-full bg-background-100 px-4 py-2 text-xs text-foreground-500 ring-1 ring-background-200">
            当前围观话题 · 真实营业观
          </span>
        </div>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-3">
        {viewpoints.map((v, i) => (
          <div key={v.name} className="flex flex-col rounded-2xl border border-background-200 bg-background-50 p-5 md:p-6">
            <div className="mb-4 flex items-center gap-3">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-secondary-100 font-label text-sm font-bold text-secondary-800">
                {v.name.slice(0, 1)}
              </div>
              <div>
                <p className="text-sm font-medium text-foreground-950">{v.name}</p>
                <span className="inline-flex items-center gap-1 text-xs text-secondary-700">
                  <i className="ri-voiceprint-line"></i>
                  {v.stance}
                </span>
              </div>
            </div>
            <p className="mb-5 flex-1 text-sm leading-relaxed text-foreground-700">{v.text}</p>

            <div className="rounded-xl bg-background-100 p-3">
              <div className="mb-1.5 flex items-center justify-between text-xs text-foreground-500">
                <span>认同占比</span>
                <span className="font-semibold text-primary-600">{v.vote} 万</span>
              </div>
              <div className="h-2 w-full overflow-hidden rounded-full bg-background-200">
                <div
                  className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                  style={{ width: `${Math.min(96, v.vote * 8)}%` }}
                />
              </div>
            </div>

            <button
              onClick={() => agree(i, v)}
              className={`mt-4 flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full px-4 py-2.5 text-sm font-medium transition ${
                picked[i]
                  ? "bg-primary-500 text-background-50"
                  : "border border-primary-200 bg-primary-50 text-primary-700 hover:bg-primary-100"
              }`}
            >
              <i className={picked[i] ? "ri-hand-heart-fill" : "ri-hand-heart-line"}></i>
              {picked[i] ? "已认同此观点" : "认同此观点"} · {v.likes.toLocaleString()}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
}